module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Beach/Nagano_Beach_MIROC5_RCP26_Now.png";